import canopyUrls from 'canopy-urls!sofe';
import { fetchAsObservable } from 'fetcher!sofe';
import { pluck } from 'rxjs/operators';

const headers = typeof Headers !== 'undefined'
  ? new Headers({
      'Content-Type': 'application/json',
    })
  : {};

export function getStatuses(serviceType) {
  return fetchAsObservable(
    `${canopyUrls.getWorkflowUrl()}/api/task-statuses?service_type${serviceType ? '=' + serviceType : ''}`
  ).pipe(pluck('task_statuses'));
}

export function addStatus(userId, status) {
  return fetchAsObservable(
    `${canopyUrls.getWorkflowUrl()}/api/task-statuses`,
    {
      method: 'POST',
      headers,
      body: `{"task_statuses": ${JSON.stringify(status)}}`,
    }
  ).pipe(pluck('task_statuses'));
}

export function removeStatus(id) {
  return fetchAsObservable(
    `${canopyUrls.getWorkflowUrl()}/api/task-statuses/${id}:archive`,
    {
      method: 'POST',
      headers,
    }
  ).pipe(pluck('task_statuses'));
}

export function unremoveStatus(id) {
  return fetchAsObservable(
    `${canopyUrls.getWorkflowUrl()}/api/task-statuses/${id}:unarchive`,
    {
      method: 'POST',
      headers,
    }
  ).pipe(pluck('task_statuses'));
}
